import { Subtenant } from '@bioliberty/lifemind';
import { ColumnDef } from '@tanstack/react-table';
import { SortableHeader } from '../../components/DataTable/SortableHeader';
import { ClinicTableActions } from '../components/ClinicTableActions';

export function useClinicsListColumns() {
  const columns: ColumnDef<Subtenant>[] = [
    {
      accessorKey: 'label',
      header: ({ column }) => <SortableHeader column={column}>Name</SortableHeader>
    },
    {
      accessorKey: 'name',
      header: ({ column }) => <SortableHeader column={column}>ID</SortableHeader>
    },
    {
      accessorKey: 'timezone',
      header: ({ column }) => <SortableHeader column={column}>Time Zone</SortableHeader>
    },
    {
      accessorKey: 'monthlyCapacity',
      header: ({ column }) => <SortableHeader column={column}>Monthly Census</SortableHeader>
    },
    {
      accessorKey: 'lifeglovLinerStockLowThreshold',
      header: ({ column }) => <SortableHeader column={column}>Low Stock Threshold</SortableHeader>
    },
    {
      accessorKey: 'inactive',
      header: ({ column }) => <SortableHeader column={column}>Status</SortableHeader>,
      cell: ({ row }) => (row.original.inactive ? 'Inactive' : 'Active'),
      sortingFn: (a, b) => Number(a.original.inactive) - Number(b.original.inactive)
    },
    {
      accessorKey: 'actions',
      header: '',
      size: 50,
      cell: ({ row }) => <ClinicTableActions clinic={row.original} />
    }
  ];

  return columns;
}
